import { Tab } from 'coreOld/elements';
import { ITab } from 'coreOld/types';

import { Wrapper } from './tabsStyle';

interface IProps {
  tabs: ITab[];
  onClick: (tab: ITab) => void;
}

const TabsNavigation = ({ tabs, onClick }: IProps) => {
  return (
    <Wrapper>
      {tabs.map((tab, index) => (
        <Tab
          key={index}
          icon={tab.icon}
          title={tab.title}
          url={tab?.path}
          onClick={() => onClick(tab)}
        />
      ))}
    </Wrapper>
  );
};

export default TabsNavigation;
